const RoleList = [1,2,3,9];


function RoleName(Role){
    switch(Role){
        case 1: return 'ผู้ใช้งาน';
        case 2 :return 'ร้านค้า';
        case 3 :return 'เจ้าหน้าที่';
        case 9 :return 'ผู้ดูแลระบบ';
        default: return '-';
    }
} 


export  {
    RoleList,
    RoleName
}